module.exports = __webpack_public_path__ + "img/new-rest.3655f0b3.svg";